@if (answer) {
  <span>{{ answer.text }}</span>
  @if (answer.references && answer.references.length > 0) {
    @for (ref of answer.references; track ref) {
      <app-new-source-preview-button
        [adaptedReference]="ref"
        (buttonClicked)="openSourceModal.emit($event)"
      ></app-new-source-preview-button>
    }
  }
}

